<script context='module'>
    import {crumbs} from './BreadCrumbs.svelte';

	import UserManagement from '../Users/Manage.svelte';
    import AssessmentList from '../Assessments/AssessmentList.svelte';
    import AssessmentAddEdit from '../Assessments/CreateAssessment.svelte';

    let Routes = {
        "UserManager": {
            name: "User Management",
            component: UserManagement
        },
        "AssessmentList": {
            name: "Assessments",
            component: AssessmentList
        },
        "AssessmentAddEdit": {
            name: "Add or Edit Assessment",
            component: AssessmentAddEdit
        }
    }

    export function navigate(route, props) {
        let selected_route = Routes[route];
        let new_route = {
            name: selected_route.name,
            component: selected_route.component,
            data: props
        }
        crumbs.set([new_route]);
    }
</script>